<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import {
		storeElementID,
		storeData,
		storeSelectedIcon,
		storeBlockTemplate,
		
	} from '../../library/scripts/Store.svelte'
	import {
		get_initial_values,
		get_logo_values,
		get_element_tags,
		string_to_fontsize,
		get_blocks,
	} from '../builderUtils'
	import { reorder_layout } from '../../library/scripts/utils'
	import ColorSelector from '../ColorSelector.svelte'
	import SizeSelector from '../SizeSelector.svelte'
	import SelectValues from '../SelectValues.svelte'
	import Shader from '../../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../../library/ShadersAndSpinners/SpinnerCircle.svelte'

	export let width

	const globals = getContext('globals')
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const icon = globals.icon
	const iconColor = globals.colorDark
	const iconHover = globals.colorError
	const bgTitle = globals.bgTitle
	let iconTitleWeight = globals.colorDark
	let iconTitleStyle = globals.colorDark
	let iconTitleDeco = globals.colorDark
	let iconTitleStroke = globals.colorDark
	let iconTitleAlignL = globals.colorDark
	let iconTitleAlignC = globals.colorDark
	let iconTitleAlignR = globals.colorDark
	let iconTextWeight = globals.colorDark
	let iconTextStyle = globals.colorDark
	let iconTextDeco = globals.colorDark
	let iconTextStroke = globals.colorDark
	let iconTextAlignL = globals.colorDark
	let iconTextAlignC = globals.colorDark
	let iconTextAlignR = globals.colorDark
	let iconTextAlignJ = globals.colorDark
	let iconTextVAlignT = globals.colorDark
	let iconTextVAlignC = globals.colorDark
	let iconTextVAlignB = globals.colorDark
	let mainTool = globals.mainTool
	let subTool = globals.subTool

	let mainToolHover = globals.mainToolHover
	let subToolHover = globals.subToolHover

	// font
	const fontSize = globals.fontSize
	const fontFamily = globals.fontFamily

	let elementID
	let config
	let blocks
	let blockID

	//show hide tool
	let generalTool1 = false
	let generalTool2 = false
	let generalTool3 = false
	let generalTool4 = false
	let showTool0 = false
	let showTool1 = false
	let showTool2 = false
	let showTool3 = false
	let showTool4 = false
	let showTool5 = false
	let showTool6 = false
	let showTool7 = false
	let showTool8 = false
	let showTool9 = false
	let showTool10 = false
	let showTool11 = false
	let showTool12 = false
	let showTool13 = false
	let showTool14 = false
	let showTool15 = false
	let showTool16 = false
	let showTool17 = false
	let showTool18 = false
	let showTool19 = false

	//change layout order
	let shaderChangeOrder = false

	//the selectedIcon from store
	let selectedStoreIcon

	//the values to send to sizeSelectors
	let selectedBorderWidth
	let selectedImageBorderWidth
	let selectedTitleBorderWidth
	let selectedTextBorderWidth

	//css selections
	let selectedHeight
	let selectedBorderColor = 'hsla(0,0%,0%,1)'
	let selectedImageBorderColor = 'hsla(0,0%,0%,1)'
	let selectedTitleBorderColor = 'hsla(0,0%,0%,1)'
	let selectedTextBorderColor = 'hsla(0,0%,0%,1)'
	let selectedBackground
	let selectedColor
	let selectedBgOpac
	let selectedImageBgOpac
	let selectedMarginTop
	let selectedMarginBottom
	let selectedPadding
	let selectedBLwidth
	let selectedBLcolor
	let selectedBTwidth
	let selectedBTcolor
	let selectedBRwidth
	let selectedBRcolor
	let selectedBBwidth
	let selectedBBcolor
	let selectedBTradius
	let selectedBBradius
	let selectedSColor
	let selectedSY
	let selectedSBlur
	let selectedSOpac
	let selectedImageWidth
	let selectedImageHeight
	let selectedImageLeft
	let selectedImageTop
	let selectedBILwidth
	let selectedBILcolor
	let selectedBITwidth
	let selectedBITcolor
	let selectedBIRwidth
	let selectedBIRcolor
	let selectedBIBwidth
	let selectedBIBcolor
	let selectedBITradius
	let selectedBIBradius
	let selectedBIScolor
	let selectedBISopac
	let selectedSIX
	let selectedSIY
	let selectedSIBlur
	let selectedTitleBgColor
	let selectedTitleBgOpac
	let selectedTitleFontColor
	let selectedTitleFontOpac
	let selectedTitleWidth
	let selectedTitleHeight
	let selectedTitleLeft
	let selectedTitleTop
	let selectedTitleFontFamily
	let selectedTitleFontSize
	let selectedBTLwidth
	let selectedBTLcolor
	let selectedBTTwidth
	let selectedBTTcolor
	let selectedBTRwidth
	let selectedBTRcolor
	let selectedBTBwidth
	let selectedBTBcolor
	let selectedTitleBorderOpac
	let selectedBTTradius
	let selectedBTBradius
	let selectedBTScolor
	let selectedBTSopac
	let selectedSTX
	let selectedSTY
	let selectedSTBlur
	let selectedTextWidth
	let selectedTextHeight
	let selectedTextLeft
	let selectedTextTop
	let selectedBTXTLwidth
	let selectedBTXTLcolor
	let selectedBTXTTwidth
	let selectedBTXTTcolor
	let selectedBTXTRwidth
	let selectedBTXTRcolor
	let selectedBTXTBwidth
	let selectedBTXTBcolor
	let selectedTextBorderOpac
	let selectedBTXTTradius
	let selectedBTXTBradius
	let selectedTextBgColor
	let selectedTextBgOpac
	let selectedTextFontFamily
	let selectedTextFontSize
	let selectedBTXTScolor
	let selectedBTXTSopac
	let selectedSTXTX
	let selectedSTXTY
	let selectedSTXTBlur
	let selectedLogo
	let selectedTitleId
	let selectedTextId
	let titleTXTSC
	let titleTXTSX
	let titleTXTSY
	let titleTXTSB
	let titleTXTSO

	//comes from logo block
	let selectedLogoBgColor
	let selectedLogoBgOpac
	let selectedLogoHeight
	let selectedLogoTop
	let selectedLogoLeft

	//icon selected
	let selectedIcon

	//set icons
	let icon1 = false
	let icon2 = false
	let icon3 = false
	let icon4 = false
	let icon5 = false
	let icon6 = false
	let icon7 = false
	let icon8 = false
	let icon9 = false
	let icon10 = false
	let icon11 = false
	let icon12 = false
	let icon13 = false
	let icon14 = false
	let icon15 = false
	let icon16 = false
	let icon17 = false
	let icon18 = false
	let icon19 = false
	let icon20 = false

	let icon1Color = iconColor
	let icon2Color = iconColor
	let icon3Color = iconColor
	let icon4Color = iconColor
	let icon5Color = iconColor
	let icon6Color = iconColor
	let icon7Color = iconColor
	let icon8Color = iconColor
	let icon9Color = iconColor
	let icon10Color = iconColor
	let icon11Color = iconColor
	let icon12Color = iconColor
	let icon13Color = iconColor
	let icon14Color = iconColor
	let icon15Color = iconColor
	let icon16Color = iconColor
	let icon17Color = iconColor
	let icon18Color = iconColor
	let icon19Color = iconColor
	let icon20Color = iconColor

	//stative ID for getElementById in SelectValues
	let idSelect1 = 'selFont'
	let idSelect2 = 'selSize'
	let idSelect3 = 'selTextFont'
	let idSelect4 = 'selTextSize'
	const idColor1 = '101'
	const idColor2 = '102'
	const idColor3 = '103'
	const idColor4 = '104'
	const idColor5 = '105'
	const idColor6 = '106'
	const idColor7 = '107'
	const idColor8 = '108'
	const idColor9 = '109'
	const idColor10 = '110'
	const idColor11 = '111'
	const idColor12 = '112'
	const idColor13 = '113'
	const idColor14 = '114'
	const idColor15 = '115'
	const idMarginTop = '3'
	const idMarginBottom = '4'
	const idPadding = '5'
	const idBorderWidth = '6'
	const idBTradius = '7'
	const idBBradius = '8'
	const idShadowY = '15'
	const idShadowBlur = '16'
	const idHeight = '20'
	const idImageWidth = '13'
	const idImageHeight = '28'
	const idImageBorderWidth = '23'
	const idImageBTradius = '24'
	const idImageBBradius = '25'
	const idImageShadowX = '14'
	const idImageShadowY = '10'
	const idImageShadowBlur = '11'
	const idTitleWidth = '18'
	const idTitleHeight = '29'
	const idTitleLeft = '21'
	const idTitleTop = '22'
	const idTitleBorderWidth = '19'
	const idTitleBTradius = '30'
	const idTitleBBradius = '31'
	const idTitleShadowX = '32'
	const idTitleShadowY = '33'
	const idTitleShadowBlur = '34'
	const idTextWidth = '12'
	const idTextHeight = '9'
	const idTextLeft = '17'
	const idTextTop = '26'
	const idTextBorderWidth = '27'
	const idTextBTradius = '35'
	const idTextBBradius = '36'
	const idTextShadowX = '37'
	const idTextShadowY = '38'
	const idTextShadowBlur = '39'
	const idImageLeft = '40'
	const idImageTop = '41'
	const idLogoSize = '42'
	const idLogoLeft = '43'
	const idLogoTop = '44'
	const idTXTSX = '45'
	const idTXTSY = '46'
	const idTXTSB = '47'
	//show border tools
	let iconSelected = false
	let selectedImageBorderIcon = false
	let selectedTitleBorderIcon = false
	let selectedTextBorderIcon = false

	//template
	let template

	const stoTemplate = storeBlockTemplate.subscribe((value) => {
		template = value
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			blocks = value.blocks
		}
	})

	const stoSelectedIcon = storeSelectedIcon.subscribe((value) => {
		selectedStoreIcon = value
	})

	//set the initial css values from config.json
	$: if (elementID.indexOf('singleImageBlock') > -1) {
		const tags = get_element_tags(elementID)
		blockID = tags[0]
		const values = get_initial_values(elementID, blocks, tags)
		selectedHeight = values[0]
		selectedBackground = values[1]
		selectedBgOpac = values[2]
		selectedMarginTop = values[3]
		selectedMarginBottom = values[4]
		selectedPadding = values[5]
		selectedBLwidth = values[6]
		selectedBLcolor = values[7]
		selectedBTwidth = values[8]
		selectedBTcolor = values[9]
		selectedBRwidth = values[10]
		selectedBRcolor = values[11]
		selectedBBwidth = values[12]
		selectedBBcolor = values[13]
		selectedBTradius = values[14]
		selectedBBradius = values[15]
		selectedSY = values[16]
		selectedSBlur = values[17]
		selectedSColor = values[18]
		selectedSOpac = values[19]
		selectedImageWidth = values[20]
		selectedImageHeight = values[21]
		selectedImageLeft = values[22]
		selectedImageTop = values[23]
		selectedBILwidth = values[24]
		selectedBILcolor = values[25]
		selectedBITwidth = values[26]
		selectedBITcolor = values[27]
		selectedBIRwidth = values[28]
		selectedBIRcolor = values[29]
		selectedBIBwidth = values[30]
		selectedBIBcolor = values[31]
		selectedBITradius = values[32]
		selectedBIBradius = values[33]
		selectedBIScolor = values[34]
		selectedBISopac = values[35]
		selectedSIX = values[36]
		selectedSIY = values[37]
		selectedSIBlur = values[38]
		selectedTitleFontColor = values[39]
		selectedTitleFontOpac = values[40]
		selectedTitleBgColor = values[41]
		selectedTitleBgOpac = values[42]
		selectedTitleWidth = values[43]
		selectedTitleHeight = values[44]
		selectedTitleLeft = values[45]
		selectedTitleTop = values[46]
		selectedTitleFontFamily = values[47]
		selectedTitleFontSize = values[48]
		selectedBTLwidth = values[49]
		selectedBTLcolor = values[50]
		selectedBTTwidth = values[51]
		selectedBTTcolor = values[52]
		selectedBTRwidth = values[53]
		selectedBTRcolor = values[54]
		selectedBTBwidth = values[55]
		selectedBTBcolor = values[56]
		selectedBTTradius = values[57]
		selectedBTBradius = values[58]
		selectedBTScolor = values[59]
		selectedBTSopac = values[60]
		selectedSTX = values[61]
		selectedSTY = values[62]
		selectedSTBlur = values[63]
		selectedTextWidth = values[64]
		selectedTextHeight = values[65]
		selectedTextLeft = values[66]
		selectedTextTop = values[67]
		selectedBTXTLwidth = values[68]
		selectedBTXTLcolor = values[69]
		selectedBTXTTwidth = values[70]
		selectedBTXTTcolor = values[71]
		selectedBTXTRwidth = values[72]
		selectedBTXTRcolor = values[73]
		selectedBTXTBwidth = values[74]
		selectedBTXTBcolor = values[75]
		selectedBTXTTradius = values[76]
		selectedBTXTBradius = values[77]
		selectedTextBgColor = values[78]
		selectedTextBgOpac = values[79]
		selectedTextFontFamily = values[80]
		selectedTextFontSize = values[81]
		selectedBTXTScolor = values[82]
		selectedBTXTSopac = values[83]
		selectedSTXTX = values[84]
		selectedSTXTY = values[85]
		selectedSTXTBlur = values[86]
		selectedLogo = values[87]
		selectedTitleId = values[88]
		selectedTextId = values[89]
		set_fontstyle_initial_value('title', values[90], values[91], values[92])
		set_fontstyle_initial_value('text', values[93], values[94], values[95])
		set_text_alignment_initial_value(values[96])
		titleTXTSC = values[97]
		titleTXTSX = values[98]
		titleTXTSY = values[99]
		titleTXTSB = values[100]
		titleTXTSO = values[101]
		set_title_alignment_initial_value(values[102])

		if (selectedBLwidth > 0) {
			icon1 = true
			set_icon_color('left', 1)
		}
		if (selectedBTwidth > 0) {
			icon2 = true
			set_icon_color('top', 2)
		}

		if (selectedBRwidth > 0) {
			icon3 = true
			set_icon_color('right', 3)
		}

		if (selectedBBwidth > 0) {
			icon4 = true
			set_icon_color('bottom', 4)
		}

		if (selectedBLwidth > 0 && selectedBTwidth > 0 && selectedBRwidth > 0 && selectedBBwidth > 0) {
			icon1 = true
			icon2 = true
			icon3 = true
			icon4 = true
			icon5 = true
			set_icon_color('all', 5)
		}

		if (selectedBILwidth > 0) {
			icon6 = true
			set_icon_color('left', 6)
		}
		if (selectedBITwidth > 0) {
			icon7 = true
			set_icon_color('top', 7)
		}

		if (selectedBIRwidth > 0) {
			icon8 = true
			set_icon_color('right', 8)
		}

		if (selectedBIBwidth > 0) {
			icon9 = true
			set_icon_color('bottom', 9)
		}

		if (selectedBILwidth > 0 && selectedBITwidth > 0 && selectedBIRwidth > 0 && selectedBIBwidth > 0) {
			icon6 = true
			icon7 = true
			icon8 = true
			icon9 = true
			icon10 = true
			set_icon_color('all', 10)
		}

		if (selectedBTLwidth > 0) {
			icon11 = true
			set_icon_color('left', 11)
		}
		if (selectedBTTwidth > 0) {
			icon12 = true
			set_icon_color('top', 12)
		}

		if (selectedBTRwidth > 0) {
			icon13 = true
			set_icon_color('right', 13)
		}

		if (selectedBTBwidth > 0) {
			icon14 = true
			set_icon_color('bottom', 14)
		}

		if (selectedBTLwidth > 0 && selectedBTTwidth > 0 && selectedBTRwidth > 0 && selectedBTBwidth > 0) {
			icon11 = true
			icon12 = true
			icon13 = true
			icon14 = true
			icon15 = true
			set_icon_color('all', 15)
		}

		if (selectedBTXTLwidth > 0) {
			icon16 = true
			set_icon_color('left', 16)
		}
		if (selectedBTXTTwidth > 0) {
			icon17 = true
			set_icon_color('top', 17)
		}

		if (selectedBTXTRwidth > 0) {
			icon18 = true
			set_icon_color('right', 18)
		}

		if (selectedBTXTBwidth > 0) {
			icon19 = true
			set_icon_color('bottom', 19)
		}

		if (selectedBTXTLwidth > 0 && selectedBTXTTwidth > 0 && selectedBTXTRwidth > 0 && selectedBTXTBwidth > 0) {
			icon16 = true
			icon17 = true
			icon18 = true
			icon19 = true
			icon20 = true
			set_icon_color('all', 20)
		}
	}

	//get the logo presets from config file if logo is added
	$: if (selectedLogo) {
		const values = get_logo_values(config)
		selectedLogoBgColor = values[0]
		selectedLogoBgOpac = values[1]
		selectedLogoHeight = values[2]
		selectedLogoTop = values[3]
		selectedLogoLeft = values[4]
	}

	$: if (!icon1 && !icon2 && !icon3 && !icon4 && !icon5) iconSelected = false
	$: if (!icon6 && !icon7 && !icon8 && !icon9 && !icon10) selectedImageBorderIcon = false
	$: if (!icon11 && !icon12 && !icon13 && !icon14 && !icon15) selectedTitleBorderIcon = false
	$: if (!icon16 && !icon17 && !icon18 && !icon19 && !icon20) selectedTextBorderIcon = false

	//block
	$: if (selectedStoreIcon === 'icon1') selectedBorderWidth = selectedBLwidth
	$: if (selectedStoreIcon === 'icon2') selectedBorderWidth = selectedBTwidth
	$: if (selectedStoreIcon === 'icon3') selectedBorderWidth = selectedBRwidth
	$: if (selectedStoreIcon === 'icon4') selectedBorderWidth = selectedBBwidth
	$: if (selectedStoreIcon === 'icon5') selectedBorderWidth = selectedBLwidth

	//image
	$: if (selectedStoreIcon === 'icon6') selectedImageBorderWidth = selectedBILwidth
	$: if (selectedStoreIcon === 'icon7') selectedImageBorderWidth = selectedBITwidth
	$: if (selectedStoreIcon === 'icon8') selectedImageBorderWidth = selectedBIRwidth
	$: if (selectedStoreIcon === 'icon9') selectedImageBorderWidth = selectedBIBwidth
	$: if (selectedStoreIcon === 'icon10') selectedImageBorderWidth = selectedBILwidth

	//title
	$: if (selectedStoreIcon === 'icon11') selectedTitleBorderWidth = selectedBTLwidth
	$: if (selectedStoreIcon === 'icon12') selectedTitleBorderWidth = selectedBTTwidth
	$: if (selectedStoreIcon === 'icon13') selectedTitleBorderWidth = selectedBTRwidth
	$: if (selectedStoreIcon === 'icon14') selectedTitleBorderWidth = selectedBTBwidth
	$: if (selectedStoreIcon === 'icon15') selectedTitleBorderWidth = selectedBTLwidth

	//text
	$: if (selectedStoreIcon === 'icon16') selectedTextBorderWidth = selectedBTXTLwidth
	$: if (selectedStoreIcon === 'icon17') selectedTextBorderWidth = selectedBTXTTwidth
	$: if (selectedStoreIcon === 'icon18') selectedTextBorderWidth = selectedBTXTRwidth
	$: if (selectedStoreIcon === 'icon19') selectedTextBorderWidth = selectedBTXTBwidth
	$: if (selectedStoreIcon === 'icon20') selectedTextBorderWidth = selectedBTXTLwidth

	const set_icon_color = (c, iNum) => {
		if (c === 'left') {
			if (iNum === 1) icon1Color = iconHover
			if (iNum === 6) icon6Color = iconHover
			if (iNum === 11) icon11Color = iconHover
			if (iNum === 16) icon11Color = iconHover
		}
		if (c === 'top') {
			if (iNum === 2) icon2Color = iconHover
			if (iNum === 7) icon7Color = iconHover
			if (iNum === 12) icon12Color = iconHover
			if (iNum === 17) icon11Color = iconHover
		}
		if (c === 'right') {
			if (iNum === 3) icon3Color = iconHover
			if (iNum === 8) icon8Color = iconHover
			if (iNum === 13) icon13Color = iconHover
			if (iNum === 18) icon11Color = iconHover
		}
		if (c === 'bottom') {
			if (iNum === 4) icon4Color = iconHover
			if (iNum === 9) icon9Color = iconHover
			if (iNum === 14) icon14Color = iconHover
			if (iNum === 19) icon11Color = iconHover
		}
		if (c === 'all') {
			if (iNum === 5) {
				icon1Color = iconHover
				icon2Color = iconHover
				icon3Color = iconHover
				icon4Color = iconHover
				icon5Color = iconHover
			}

			if (iNum === 10) {
				icon6Color = iconHover
				icon7Color = iconHover
				icon8Color = iconHover
				icon9Color = iconHover
				icon10Color = iconHover
			}

			if (iNum === 15) {
				icon11Color = iconHover
				icon12Color = iconHover
				icon13Color = iconHover
				icon14Color = iconHover
				icon15Color = iconHover
			}

			if (iNum === 20) {
				icon16Color = iconHover
				icon17Color = iconHover
				icon18Color = iconHover
				icon19Color = iconHover
				icon20Color = iconHover
			}
		}
		if (c === 'none') {
			if (iNum === 5) {
				icon1Color = iconColor
				icon2Color = iconColor
				icon3Color = iconColor
				icon4Color = iconColor
				icon5Color = iconColor
			}
			if (iNum === 10) {
				icon6Color = iconColor
				icon7Color = iconColor
				icon8Color = iconColor
				icon9Color = iconColor
				icon10Color = iconColor
			}

			if (iNum === 15) {
				icon11Color = iconColor
				icon12Color = iconColor
				icon13Color = iconColor
				icon14Color = iconColor
				icon15Color = iconColor
			}

			if (iNum === 20) {
				icon16Color = iconColor
				icon17Color = iconColor
				icon18Color = iconColor
				icon19Color = iconColor
				icon20Color = iconColor
			}
		}
	}
	const set_fontstyle_initial_value = (c, w, s, d) => {
		if (c === 'title') {
			if (w === 'bold') iconTitleWeight = iconHover
			if (w === 'normal') iconTitleWeight = iconColor
			if (s === 'italic') iconTitleStyle = iconHover
			if (s === 'normal') iconTitleStyle = iconColor
			if (d === 'none') {
				iconTitleDeco = iconColor
				iconTitleStroke = iconColor
			}
			if (d === 'underline') {
				iconTitleDeco = iconHover
				iconTitleStroke = iconColor
			}
			if (d === 'line-through') {
				iconTitleDeco = iconColor
				iconTitleStroke = iconHover
			}
		}

		if (c === 'text') {
			if (w === 'bold') iconTextWeight = iconHover
			if (w === 'normal') iconTextWeight = iconColor
			if (s === 'italic') iconTextStyle = iconHover
			if (s === 'normal') iconTextStyle = iconColor
			if (d === 'none') {
				iconTextDeco = iconColor
				iconTextStroke = iconColor
			}
			if (d === 'underline') {
				iconTextDeco = iconHover
				iconTextStroke = iconColor
			}
			if (d === 'line-through') {
				iconTextDeco = iconColor
				iconTextStroke = iconHover
			}
		}
	}

	const set_text_alignment_initial_value = (v) => {
		switch (v) {
			case 'left':
				iconTextAlignL = iconHover
				iconTextAlignC = iconColor
				iconTextAlignR = iconColor
				iconTextAlignJ = iconColor
				break

			case 'center':
				iconTextAlignL = iconColor
				iconTextAlignC = iconHover
				iconTextAlignR = iconColor
				iconTextAlignJ = iconColor
				break

			case 'right':
				iconTextAlignL = iconColor
				iconTextAlignC = iconColor
				iconTextAlignR = iconHover
				iconTextAlignJ = iconColor
				break

			case 'justify':
				iconTextAlignL = iconColor
				iconTextAlignC = iconColor
				iconTextAlignR = iconColor
				iconTextAlignJ = iconHover
				break
		}
	}

	const set_title_alignment_initial_value = (v) => {
		switch (v) {
			case 'flex-start':
				iconTitleAlignL = iconHover
				iconTitleAlignC = iconColor
				iconTitleAlignR = iconColor
				break

			case 'center':
				iconTitleAlignL = iconColor
				iconTitleAlignC = iconHover
				iconTitleAlignR = iconColor
				break

			case 'flex-end':
				iconTitleAlignL = iconColor
				iconTitleAlignC = iconColor
				iconTitleAlignR = iconHover
				break
		}
	}

	const set_logo_tag = (cssTag, cmd) => {
		if (cmd === 'logoBg') config.logo.backgroundColor = cssTag
		if (cmd === 'size') config.logo.imageHeight = cssTag
		if (cmd === 'top') config.logo.top = cssTag
		if (cmd === 'left') config.logo.left = cssTag

		storeData.set(config)
	}

	const set_css_tag = (cssTag, cmd) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (cmd === 'bg') {
					block.sibBackgroundColor = cssTag
				}

				if (cmd === 'bgTitle') {
					block.sibTitleBackground = cssTag
				}

				if (cmd === 'bgText') {
					block.sibTextBackground = cssTag
				}

				if (cmd === 'fontColorTitle') {
					block.sibTitleFontColor = cssTag
				}

				if (cmd === 'fontColorText') {
					block.sibTextFontColor = cssTag
				}

				if (cmd === 'bL') {
					if (icon1 && selectedIcon === 'icon1') {
						block.sibBorderLeftColor = cssTag
						block.sibBorderLeftWidth = '1'
						icon1Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.sibBorderLeftWidth = '0'
						icon1Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bIL') {
					if (icon6 && selectedIcon === 'icon6') {
						block.sibImageBorderLeftColor = cssTag
						block.sibImageBorderLeftWidth = '1'
						icon6Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.sibImageBorderLeftWidth = '0'
						icon6Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'bTTL') {
					if (icon11 && selectedIcon === 'icon11') {
						block.sibTitleBorderLeftColor = cssTag
						block.sibTitleBorderLeftWidth = '1'
						icon11Color = iconHover
						if (icon11 && icon12 && icon13 && icon14) icon15Color = iconHover
					} else {
						block.sibTitleBorderLeftWidth = '0'
						icon11Color = iconColor
						icon15Color = iconColor
					}
				}

				if (cmd === 'bTXTL') {
					if (icon16 && selectedIcon === 'icon16') {
						block.sibTextBorderLeftColor = cssTag
						block.sibTextBorderLeftWidth = '1'
						icon16Color = iconHover
						if (icon16 && icon17 && icon18 && icon19) icon20Color = iconHover
					} else {
						block.sibTextBorderLeftWidth = '0'
						icon16Color = iconColor
						icon20Color = iconColor
					}
				}

				if (cmd === 'bT') {
					if (icon2 && selectedIcon === 'icon2') {
						block.sibBorderTopColor = cssTag
						block.sibBorderTopWidth = '1'
						icon2Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.sibBorderTopWidth = '0'
						icon2Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bIT') {
					if (icon7 && selectedIcon === 'icon7') {
						block.sibImageBorderTopColor = cssTag
						block.sibImageBorderTopWidth = '1'
						icon7Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.sibImageBorderTopWidth = '0'
						icon7Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'bTTT') {
					if (icon12 && selectedIcon === 'icon12') {
						block.sibTitleBorderTopColor = cssTag
						block.sibTitleBorderTopWidth = '1'
						icon12Color = iconHover
						if (icon11 && icon12 && icon13 && icon14) icon15Color = iconHover
					} else {
						block.sibTitleBorderTopWidth = '0'
						icon12Color = iconColor
						icon15Color = iconColor
					}
				}

				if (cmd === 'bTXTT') {
					if (icon17 && selectedIcon === 'icon17') {
						block.sibTextBorderTopColor = cssTag
						block.sibTextBorderTopWidth = '1'
						icon17Color = iconHover
						if (icon16 && icon17 && icon18 && icon19) icon20Color = iconHover
					} else {
						block.sibTextBorderTopWidth = '0'
						icon17Color = iconColor
						icon20Color = iconColor
					}
				}

				if (cmd === 'bR') {
					if (icon3 && selectedIcon === 'icon3') {
						block.sibBorderRightColor = cssTag
						block.sibBorderRightWidth = '1'
						icon3Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.sibBorderRightWidth = '0'
						icon3Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bIR') {
					if (icon8 && selectedIcon === 'icon8') {
						block.sibImageBorderRightColor = cssTag
						block.sibImageBorderRightWidth = '1'
						icon8Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.sibImageBorderRightWidth = '0'
						icon8Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'bTTR') {
					if (icon13 && selectedIcon === 'icon13') {
						block.sibTitleBorderRightColor = cssTag
						block.sibTitleBorderRightWidth = '1'
						icon13Color = iconHover
						if (icon11 && icon12 && icon13 && icon14) icon15Color = iconHover
					} else {
						block.sibTitleBorderRightWidth = '0'
						icon13Color = iconColor
						icon15Color = iconColor
					}
				}

				if (cmd === 'bTXTR') {
					if (icon18 && selectedIcon === 'icon18') {
						block.sibTextBorderRightColor = cssTag
						block.sibTextBorderRightWidth = '1'
						icon18Color = iconHover
						if (icon16 && icon17 && icon18 && icon19) icon20Color = iconHover
					} else {
						block.sibTextBorderRightWidth = '0'
						icon18Color = iconColor
						icon20Color = iconColor
					}
				}

				if (cmd === 'bB') {
					if (icon4 && selectedIcon === 'icon4') {
						block.sibBorderBottomColor = cssTag
						block.sibBorderBottomWidth = '1'
						icon4Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.sibBorderBottomWidth = '0'
						icon4Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bIB') {
					if (icon9 && selectedIcon === 'icon9') {
						block.sibImageBorderBottomColor = cssTag
						block.sibImageBorderBottomWidth = '1'
						icon9Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.sibImageBorderBottomWidth = '0'
						icon9Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'bTTB') {
					if (icon14 && selectedIcon === 'icon14') {
						block.sibTitleBorderBottomColor = cssTag
						block.sibTitleBorderBottomWidth = '1'
						icon14Color = iconHover
						if (icon11 && icon12 && icon13 && icon14) icon15Color = iconHover
					} else {
						block.sibTitleBorderBottomWidth = '0'
						icon14Color = iconColor
						icon15Color = iconColor
					}
				}

				if (cmd === 'bTXTB') {
					if (icon19 && selectedIcon === 'icon19') {
						block.sibTextBorderBottomColor = cssTag
						block.sibTextBorderBottomWidth = '1'
						icon19Color = iconHover
						if (icon16 && icon17 && icon18 && icon19) icon20Color = iconHover
					} else {
						block.sibTextBorderBottomWidth = '0'
						icon19Color = iconColor
						icon20Color = iconColor
					}
				}

				if (cmd === 'bA') {
					if (icon5 && selectedIcon === 'icon5') {
						block.sibBorderLeftColor = cssTag
						block.sibBorderLeftWidth = '1'
						block.sibBorderTopColor = cssTag
						block.sibBorderTopWidth = '1'
						block.sibBorderRightColor = cssTag
						block.sibBorderRightWidth = '1'
						block.sibBorderBottomColor = cssTag
						block.sibBorderBottomWidth = '1'
						icon5Color = iconHover
						icon1Color = iconHover
						icon2Color = iconHover
						icon3Color = iconHover
						icon4Color = iconHover
					} else {
						block.sibBorderLeftWidth = '0'
						block.sibBorderTopWidth = '0'
						block.sibBorderRightWidth = '0'
						block.sibBorderBottomWidth = '0'
						icon5Color = iconColor
						icon1Color = iconColor
						icon2Color = iconColor
						icon3Color = iconColor
						icon4Color = iconColor

						icon1 = false
						icon2 = false
						icon3 = false
						icon4 = false
						icon5 = false
					}
				}

				if (cmd === 'bIA') {
					if (icon10 && selectedIcon === 'icon10') {
						block.sibImageBorderLeftColor = cssTag
						block.sibImageBorderLeftWidth = '1'
						block.sibImageBorderTopColor = cssTag
						block.sibImageBorderTopWidth = '1'
						block.sibImageBorderRightColor = cssTag
						block.sibImageBorderRightWidth = '1'
						block.sibImageBorderBottomColor = cssTag
						block.sibImageBorderBottomWidth = '1'
						icon10Color = iconHover
						icon6Color = iconHover
						icon7Color = iconHover
						icon8Color = iconHover
						icon9Color = iconHover
					} else {
						block.sibImageBorderLeftWidth = '0'
						block.sibImageBorderTopWidth = '0'
						block.sibImageBorderRightWidth = '0'
						block.sibImageBorderBottomWidth = '0'
						icon10Color = iconColor
						icon6Color = iconColor
						icon7Color = iconColor
						icon8Color = iconColor
						icon9Color = iconColor

						icon6 = false
						icon7 = false
						icon8 = false
						icon9 = false
						icon10 = false
					}
				}

				if (cmd === 'bTTA') {
					if (icon15 && selectedIcon === 'icon15') {
						block.sibTitleBorderLeftColor = cssTag
						block.sibTitleBorderLeftWidth = '1'
						block.sibTitleBorderTopColor = cssTag
						block.sibTitleBorderTopWidth = '1'
						block.sibTitleBorderRightColor = cssTag
						block.sibTitleBorderRightWidth = '1'
						block.sibTitleBorderBottomColor = cssTag
						block.sibTitleBorderBottomWidth = '1'
						icon15Color = iconHover
						icon11Color = iconHover
						icon12Color = iconHover
						icon13Color = iconHover
						icon14Color = iconHover
					} else {
						block.sibTitleBorderLeftWidth = '0'
						block.sibTitleBorderTopWidth = '0'
						block.sibTitleBorderRightWidth = '0'
						block.sibTitleBorderBottomWidth = '0'
						icon15Color = iconColor
						icon11Color = iconColor
						icon12Color = iconColor
						icon13Color = iconColor
						icon14Color = iconColor

						icon11 = false
						icon12 = false
						icon13 = false
						icon14 = false
						icon15 = false
					}
				}

				if (cmd === 'bTXTA') {
					if (icon20 && selectedIcon === 'icon20') {
						block.sibTextBorderLeftColor = cssTag
						block.sibTextBorderLeftWidth = '1'
						block.sibTextBorderTopColor = cssTag
						block.sibTextBorderTopWidth = '1'
						block.sibTextBorderRightColor = cssTag
						block.sibTextBorderRightWidth = '1'
						block.sibTextBorderBottomColor = cssTag
						block.sibTextBorderBottomWidth = '1'
						icon20Color = iconHover
						icon16Color = iconHover
						icon17Color = iconHover
						icon18Color = iconHover
						icon19Color = iconHover
					} else {
						block.sibTextBorderLeftWidth = '0'
						block.sibTextBorderTopWidth = '0'
						block.sibTextBorderRightWidth = '0'
						block.sibTextBorderBottomWidth = '0'
						icon20Color = iconColor
						icon16Color = iconColor
						icon17Color = iconColor
						icon18Color = iconColor
						icon19Color = iconColor

						icon16 = false
						icon17 = false
						icon18 = false
						icon19 = false
						icon20 = false
					}
				}

				if (cmd === 'bWidth') {
					if (icon1 && selectedIcon === 'icon1') block.sibBorderLeftWidth = cssTag
					if (icon2 && selectedIcon === 'icon2') block.sibBorderTopWidth = cssTag
					if (icon3 && selectedIcon === 'icon3') block.sibBorderRightWidth = cssTag
					if (icon4 && selectedIcon === 'icon4') block.sibBorderBottomWidth = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.sibBorderLeftWidth = cssTag
						block.sibBorderTopWidth = cssTag
						block.sibBorderRightWidth = cssTag
						block.sibBorderBottomWidth = cssTag
					}
				}

				if (cmd === 'bIWidth') {
					if (icon6 && selectedIcon === 'icon6') block.sibImageBorderLeftWidth = cssTag
					if (icon7 && selectedIcon === 'icon7') block.sibImageBorderTopWidth = cssTag
					if (icon8 && selectedIcon === 'icon8') block.sibImageBorderRightWidth = cssTag
					if (icon9 && selectedIcon === 'icon9') block.sibImageBorderBottomWidth = cssTag
					if (icon10 && selectedIcon === 'icon10') {
						block.sibImageBorderLeftWidth = cssTag
						block.sibImageBorderTopWidth = cssTag
						block.sibImageBorderRightWidth = cssTag
						block.sibImageBorderBottomWidth = cssTag
					}
				}

				if (cmd === 'bTWidth') {
					if (icon11 && selectedIcon === 'icon11') block.sibTitleBorderLeftWidth = cssTag
					if (icon12 && selectedIcon === 'icon12') block.sibTitleBorderTopWidth = cssTag
					if (icon13 && selectedIcon === 'icon13') block.sibTitleBorderRightWidth = cssTag
					if (icon14 && selectedIcon === 'icon14') block.sibTitleBorderBottomWidth = cssTag
					if (icon15 && selectedIcon === 'icon15') {
						block.sibTitleBorderLeftWidth = cssTag
						block.sibTitleBorderTopWidth = cssTag
						block.sibTitleBorderRightWidth = cssTag
						block.sibTitleBorderBottomWidth = cssTag
					}
				}

				if (cmd === 'bTXTWidth') {
					if (icon16 && selectedIcon === 'icon16') block.sibTextBorderLeftWidth = cssTag
					if (icon17 && selectedIcon === 'icon17') block.sibTextBorderTopWidth = cssTag
					if (icon18 && selectedIcon === 'icon18') block.sibTextBorderRightWidth = cssTag
					if (icon19 && selectedIcon === 'icon19') block.sibTextBorderBottomWidth = cssTag
					if (icon20 && selectedIcon === 'icon20') {
						block.sibTextBorderLeftWidth = cssTag
						block.sibTextBorderTopWidth = cssTag
						block.sibTextBorderRightWidth = cssTag
						block.sibTextBorderBottomWidth = cssTag
					}
				}

				if (cmd === 'bColor') {
					if (icon1 && selectedIcon === 'icon1') block.sibBorderLeftColor = cssTag
					if (icon2 && selectedIcon === 'icon2') block.sibBorderTopColor = cssTag
					if (icon3 && selectedIcon === 'icon3') block.sibBorderRightColor = cssTag
					if (icon4 && selectedIcon === 'icon4') block.sibBorderBottomColor = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.sibBorderLeftColor = cssTag
						block.sibBorderTopColor = cssTag
						block.sibBorderRightColor = cssTag
						block.sibBorderBottomColor = cssTag
					}
				}

				if (cmd === 'bIColor') {
					if (icon6 && selectedIcon === 'icon6') block.sibImageBorderLeftColor = cssTag
					if (icon7 && selectedIcon === 'icon7') block.sibImageBorderTopColor = cssTag
					if (icon8 && selectedIcon === 'icon8') block.sibImageBorderRightColor = cssTag
					if (icon9 && selectedIcon === 'icon9') block.sibImageBorderBottomColor = cssTag
					if (icon10 && selectedIcon === 'icon10') {
						block.sibImageBorderLeftColor = cssTag
						block.sibImageBorderTopColor = cssTag
						block.sibImageBorderRightColor = cssTag
						block.sibImageBorderBottomColor = cssTag
					}
				}

				if (cmd === 'bTColor') {
					if (icon11 && selectedIcon === 'icon11') block.sibTitleBorderLeftColor = cssTag
					if (icon12 && selectedIcon === 'icon12') block.sibTitleBorderTopColor = cssTag
					if (icon13 && selectedIcon === 'icon13') block.sibTitleBorderRightColor = cssTag
					if (icon14 && selectedIcon === 'icon14') block.sibTitleBorderBottomColor = cssTag
					if (icon15 && selectedIcon === 'icon15') {
						block.sibTitleBorderLeftColor = cssTag
						block.sibTitleBorderTopColor = cssTag
						block.sibTitleBorderRightColor = cssTag
						block.sibTitleBorderBottomColor = cssTag
					}
				}

				if (cmd === 'bTXTColor') {
					if (icon16 && selectedIcon === 'icon16') block.sibTextBorderLeftColor = cssTag
					if (icon17 && selectedIcon === 'icon17') block.sibTextBorderTopColor = cssTag
					if (icon18 && selectedIcon === 'icon18') block.sibTextBorderRightColor = cssTag
					if (icon19 && selectedIcon === 'icon19') block.sibTextBorderBottomColor = cssTag
					if (icon20 && selectedIcon === 'icon20') {
						block.sibTextBorderLeftColor = cssTag
						block.sibTextBorderTopColor = cssTag
						block.sibTextBorderRightColor = cssTag
						block.sibTextBorderBottomColor = cssTag
					}
				}

				if (cmd === 'btRadius') {
					block.sibBorderTopRadius = cssTag
				}

				if (cmd === 'bttRadius') {
					block.sibTitleBorderTopRadius = cssTag
				}

				if (cmd === 'bTXTtRadius') {
					block.sibTextBorderTopRadius = cssTag
				}

				if (cmd === 'btbRadius') {
					block.sibTitleBorderBottomRadius = cssTag
				}

				if (cmd === 'bTXTbRadius') {
					block.sibTextBorderBottomRadius = cssTag
				}

				if (cmd === 'btiRadius') {
					block.sibImageBorderTopRadius = cssTag
				}

				if (cmd === 'bbRadius') {
					block.sibBorderBottomRadius = cssTag
				}

				if (cmd === 'bbiRadius') {
					block.sibImageBorderBottomRadius = cssTag
				}

				if (cmd === 'sY') {
					block.sibShadowOffsetY = cssTag
				}

				if (cmd === 'sIX') {
					block.sibImageShadowOffsetX = cssTag
				}

				if (cmd === 'sTTX') {
					block.sibTitleShadowOffsetX = cssTag
				}

				if (cmd === 'sTXTX') {
					block.sibTextShadowOffsetX = cssTag
				}

				if (cmd === 'sIY') {
					block.sibImageShadowOffsetY = cssTag
				}

				if (cmd === 'sTTY') {
					block.sibTitleShadowOffsetY = cssTag
				}

				if (cmd === 'sTXTY') {
					block.sibTextShadowOffsetY = cssTag
				}

				if (cmd === 'sB') {
					block.sibShadowBlur = cssTag
				}

				if (cmd === 'sIB') {
					block.sibImageShadowBlur = cssTag
				}

				if (cmd === 'sTTB') {
					block.sibTitleShadowBlur = cssTag
				}

				if (cmd === 'sTXTB') {
					block.sibTextShadowBlur = cssTag
				}

				if (cmd === 'sC') {
					block.sibShadowColor = cssTag
				}

				if (cmd === 'sIC') {
					block.sibImageShadowColor = cssTag
				}

				if (cmd === 'sTTC') {
					block.sibTitleShadowColor = cssTag
				}

				if (cmd === 'sTXTC') {
					block.sibTextShadowColor = cssTag
				}

				if (cmd === 'fontFamilyTitle') {
					block.sibTitleFontFamily = cssTag
				}

				if (cmd === 'fontFamilyText') {
					block.sibTextFontFamily = cssTag
				}

				if (cmd === 'fontSizeTitle') {
					block.sibTitleFontSize = cssTag
				}

				if (cmd === 'fontSizeText') {
					block.sibTextFontSize = cssTag
				}

				if (cmd === 'fontWeightTitle') {
					block.sibTitleFontWeight = cssTag
				}

				if (cmd === 'fontWeightText') {
					block.sibTextFontWeight = cssTag
				}

				if (cmd === 'fontStyleTitle') {
					block.sibTitleFontStyle = cssTag
				}

				if (cmd === 'fontStyleText') {
					block.sibTextFontStyle = cssTag
				}

				if (cmd === 'fontDecorationTitle') {
					block.sibTitleFontDeco = cssTag
				}

				if (cmd === 'fontDecorationText') {
					block.sibTextFontDeco = cssTag
				}

				if (cmd === 'flexAlign') {
					block.sibTitleJustify = cssTag
					block.blockTitleAlignHorizontal = cssTag
				}

				if (cmd === 'flexAlignText') {
					//set the flex alignment
					block.sibTextJustify = cssTag

					//set the text-alignment
					switch (cssTag) {
						case 'flex-start':
							block.sibTextAlign = 'left'
							break

						case 'center':
							block.sibTextAlign = cssTag
							break

						case 'flex-end':
							block.sibTextAlign = 'right'
							break

						case 'justify':
							block.sibTextAlign = 'justify'
							block.sibTextJustify = 'center'
							break
					}
				}

				if (cmd === 'flexVAlignText') block.sibTextAlign = cssTag

				// title shadow color
				if (cmd === 'TTXTSC') block.sibTitleTXTSC = cssTag
				if (cmd === 'TTXTSX') block.sibTitleTXTSX = cssTag
				if (cmd === 'TTXTSY') block.sibTitleTXTSY = cssTag
				if (cmd === 'TTXTSB') block.sibTitleTXTSB = cssTag
			}
		})

		config.blocks = blocks
		storeData.set(config)
	}

	const set_titleTXTSC = (e) => {
		set_css_tag(e.detail.color, 'TTXTSC')
	}

	const set_titleTXTSX = (e) => {
		set_css_tag(e.detail.value, 'TTXTSX')
	}

	const set_titleTXTSY = (e) => {
		set_css_tag(e.detail.value, 'TTXTSY')
	}

	const set_titleTXTSB = (e) => {
		set_css_tag(e.detail.value, 'TTXTSB')
	}

	const set_logo_bg_color = (e) => {
		set_logo_tag(e.detail.color, 'logoBg')
	}

	const set_logo_height = (e) => {
		set_logo_tag(e.detail.value, 'size')
	}

	const set_logo_left = (e) => {
		set_logo_tag(e.detail.value, 'left')
	}

	const set_logo_top = (e) => {
		set_logo_tag(e.detail.value, 'top')
	}

	const set_bg_color = (e) => {
		set_css_tag(e.detail.color, 'bg')
	}

	const set_title_bg_color = (e) => {
		set_css_tag(e.detail.color, 'bgTitle')
	}

	const set_text_bg_color = (e) => {
		set_css_tag(e.detail.color, 'bgText')
	}

	const set_title_font_color = (e) => {
		set_css_tag(e.detail.color, 'fontColorTitle')
	}

	const set_text_font_color = (e) => {
		set_css_tag(e.detail.color, 'fontColorText')
	}

	const set_border_color = (e) => {
		set_css_tag(e.detail.color, 'bColor')
	}

	const set_image_border_color = (e) => {
		set_css_tag(e.detail.color, 'bIColor')
	}

	const set_title_border_color = (e) => {
		set_css_tag(e.detail.color, 'bTColor')
	}

	const set_text_border_color = (e) => {
		set_css_tag(e.detail.color, 'bTXTColor')
	}

	const set_border_width = (e) => {
		set_css_tag(e.detail.value, 'bWidth')
	}

	const set_image_border_width = (e) => {
		set_css_tag(e.detail.value, 'bIWidth')
	}

	const set_title_border_width = (e) => {
		set_css_tag(e.detail.value, 'bTWidth')
	}

	const set_text_border_width = (e) => {
		set_css_tag(e.detail.value, 'bTXTWidth')
	}

	const set_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'btRadius')
	}

	const set_title_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'bttRadius')
	}

	const set_text_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'bTXTtRadius')
	}

	const set_image_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'btiRadius')
	}

	const set_title_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'btbRadius')
	}

	const set_text_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'bTXTbRadius')
	}

	const set_image_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'bbiRadius')
	}

	const set_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'bbRadius')
	}

	const set_margin_top = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibMarginTop = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_margin_bottom = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibMarginBottom = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_padding = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibPadding = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_height = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibHeight = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_image_width = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibImageWidth = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_title_width = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibTitleWidth = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_text_width = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibTextWidth = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_title_height = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibTitleHeight = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_text_height = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibTextHeight = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_image_height = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibImageHeight = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_image_left = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibImageLeft = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_title_left = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibTitleLeft = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_text_left = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibTextLeft = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_title_top = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibTitleTop = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_image_top = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibImageTop = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_text_top = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sibTextTop = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_offset_y = (e) => {
		set_css_tag(e.detail.value, 'sY')
	}

	const set_image_offset_y = (e) => {
		set_css_tag(e.detail.value, 'sIY')
	}

	const set_title_offset_y = (e) => {
		set_css_tag(e.detail.value, 'sTTY')
	}

	const set_text_offset_y = (e) => {
		set_css_tag(e.detail.value, 'sTXTY')
	}

	const set_image_offset_x = (e) => {
		set_css_tag(e.detail.value, 'sIX')
	}

	const set_title_offset_x = (e) => {
		set_css_tag(e.detail.value, 'sTTX')
	}

	const set_text_offset_x = (e) => {
		set_css_tag(e.detail.value, 'sTXTX')
	}

	const set_blur = (e) => {
		set_css_tag(e.detail.value, 'sB')
	}

	const set_image_blur = (e) => {
		set_css_tag(e.detail.value, 'sIB')
	}

	const set_title_blur = (e) => {
		set_css_tag(e.detail.value, 'sTTB')
	}

	const set_text_blur = (e) => {
		set_css_tag(e.detail.value, 'sTXTB')
	}

	const set_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'sC')
	}

	const set_image_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'sIC')
	}

	const set_title_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'sTTC')
	}

	const set_text_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'sTXTC')
	}

	const set_title_font_family = (e) => {
		set_css_tag(e.detail.font, 'fontFamilyTitle')
	}

	const set_text_font_family = (e) => {
		set_css_tag(e.detail.font, 'fontFamilyText')
	}

	const set_title_font_size = (e) => {
		const size = string_to_fontsize(e.detail.size)
		set_css_tag(size, 'fontSizeTitle')
	}

	const set_text_font_size = (e) => {
		const size = string_to_fontsize(e.detail.size)
		set_css_tag(size, 'fontSizeText')
	}

	const set_title_font_weight = () => {
		let fW = document.getElementById(selectedTitleId).style.fontWeight
		if (fW === '' || fW === 'normal') {
			set_css_tag('bold', 'fontWeightTitle')
		} else {
			set_css_tag('normal', 'fontWeightTitle')
		}
	}

	const set_text_font_weight = () => {
		let fW = document.getElementById(selectedTextId).style.fontWeight
		if (fW === '' || fW === 'normal') {
			set_css_tag('bold', 'fontWeightText')
		} else {
			set_css_tag('normal', 'fontWeightText')
		}
	}

	const set_title_font_style = () => {
		let fW = document.getElementById(selectedTitleId).style.fontStyle
		if (fW === '' || fW === 'normal') {
			set_css_tag('italic', 'fontStyleTitle')
		} else {
			set_css_tag('normal', 'fontStyleTitle')
		}
	}

	const set_text_font_style = () => {
		let fW = document.getElementById(selectedTextId).style.fontStyle
		if (fW === '' || fW === 'normal') {
			set_css_tag('italic', 'fontStyleText')
		} else {
			set_css_tag('normal', 'fontStyleText')
		}
	}

	const set_title_font_underline = () => {
		let fW = document.getElementById(selectedTitleId).style.textDecoration
		if (fW === '' || fW === 'none' || fW === 'line-through') {
			set_css_tag('underline', 'fontDecorationTitle')
		} else {
			set_css_tag('none', 'fontDecorationTitle')
		}
	}

	const set_text_font_underline = () => {
		let fW = document.getElementById(selectedTextId).style.textDecoration
		if (fW === '' || fW === 'none' || fW === 'line-through') {
			set_css_tag('underline', 'fontDecorationText')
		} else {
			set_css_tag('none', 'fontDecorationText')
		}
	}

	const set_title_font_strikethrough = () => {
		let fW = document.getElementById(selectedTitleId).style.textDecoration
		if (fW === '' || fW === 'none' || fW === 'underline') {
			set_css_tag('line-through', 'fontDecorationTitle')
		} else {
			set_css_tag('none', 'fontDecorationTitle')
		}
	}

	const set_text_font_strikethrough = () => {
		let fW = document.getElementById(selectedTextId).style.textDecoration
		if (fW === '' || fW === 'none' || fW === 'underline') {
			set_css_tag('line-through', 'fontDecorationText')
		} else {
			set_css_tag('none', 'fontDecorationText')
		}
	}

	const set_flex_align_left_title = () => {
		set_css_tag('flex-start', 'flexAlign')
	}

	const set_flex_align_left_text = () => {
		set_css_tag('flex-start', 'flexAlignText')
	}

	const set_flex_align_center_title = () => {
		set_css_tag('center', 'flexAlign')
	}

	const set_flex_align_center_text = () => {
		set_css_tag('center', 'flexAlignText')
	}

	const set_flex_align_right_title = () => {
		set_css_tag('flex-end', 'flexAlign')
	}

	const set_flex_align_right_text = () => {
		set_css_tag('flex-end', 'flexAlignText')
	}

	const set_flex_align_justify_text = () => {
		set_css_tag('justify', 'flexAlignText')
	}

	const set_flex_valign_top_text = () => {
		set_css_tag('flex-start', 'flexVAlignText')
	}

	const set_flex_valign_center_text = () => {
		set_css_tag('center', 'flexVAlignText')
	}

	const set_flex_valign_bottom_text = () => {
		set_css_tag('flex-end', 'flexVAlignText')
	}

	const set_icon_1 = () => {
		iconSelected = true
		selectedIcon = 'icon1'
		storeSelectedIcon.set('icon1')
		icon1 = icon1 === false ? true : false
		if (icon1) icon1Color = iconHover
		else icon1Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bL')
	}

	const set_icon_2 = () => {
		iconSelected = true
		selectedIcon = 'icon2'
		storeSelectedIcon.set('icon2')
		icon2 = icon2 === false ? true : false
		if (icon2) icon2Color = iconHover
		else icon2Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bT')
	}

	const set_icon_3 = () => {
		iconSelected = true
		selectedIcon = 'icon3'
		storeSelectedIcon.set('icon3')
		icon3 = icon3 === false ? true : false
		if (icon3) icon3Color = iconHover
		else icon3Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bR')
	}

	const set_icon_4 = () => {
		iconSelected = true
		selectedIcon = 'icon4'
		storeSelectedIcon.set('icon4')
		icon4 = icon4 === false ? true : false
		if (icon4) icon4Color = iconHover
		else icon4Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bB')
	}

	const set_icon_5 = () => {
		iconSelected = true
		selectedIcon = 'icon5'
		storeSelectedIcon.set('icon5')
		icon5 = icon5 === false ? true : false
		if (icon5) icon5Color = iconHover
		else icon5Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bA')
	}

	const set_icon_6 = () => {
		selectedImageBorderIcon = true
		selectedIcon = 'icon6'
		storeSelectedIcon.set('icon6')
		icon6 = icon6 === false ? true : false
		if (icon6) icon6Color = iconHover
		else icon6Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bIL')
	}

	const set_icon_7 = () => {
		selectedImageBorderIcon = true
		selectedIcon = 'icon7'
		storeSelectedIcon.set('icon7')
		icon7 = icon7 === false ? true : false
		if (icon7) icon7Color = iconHover
		else icon7Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bIT')
	}

	const set_icon_8 = () => {
		selectedImageBorderIcon = true
		selectedIcon = 'icon8'
		storeSelectedIcon.set('icon8')
		icon8 = icon8 === false ? true : false
		if (icon8) icon8Color = iconHover
		else icon8Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bIR')
	}

	const set_icon_9 = () => {
		selectedImageBorderIcon = true
		selectedIcon = 'icon9'
		storeSelectedIcon.set('icon9')
		icon9 = icon9 === false ? true : false
		if (icon9) icon9Color = iconHover
		else icon9Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bIB')
	}

	const set_icon_10 = () => {
		selectedImageBorderIcon = true
		selectedIcon = 'icon10'
		storeSelectedIcon.set('icon10')
		icon10 = icon10 === false ? true : false
		if (icon10) icon10Color = iconHover
		else icon10Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bIA')
	}

	const set_icon_11 = () => {
		selectedTitleBorderIcon = true
		selectedIcon = 'icon11'
		storeSelectedIcon.set('icon11')
		icon11 = icon11 === false ? true : false
		if (icon11) icon11Color = iconHover
		else icon11Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bTTL')
	}

	const set_icon_12 = () => {
		selectedTitleBorderIcon = true
		selectedIcon = 'icon12'
		storeSelectedIcon.set('icon12')
		icon12 = icon12 === false ? true : false
		if (icon12) icon12Color = iconHover
		else icon12Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bTTT')
	}

	const set_icon_13 = () => {
		selectedTitleBorderIcon = true
		selectedIcon = 'icon13'
		storeSelectedIcon.set('icon13')
		icon13 = icon13 === false ? true : false
		if (icon13) icon13Color = iconHover
		else icon13Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bTTR')
	}

	const set_icon_14 = () => {
		selectedTitleBorderIcon = true
		selectedIcon = 'icon14'
		storeSelectedIcon.set('icon14')
		icon14 = icon14 === false ? true : false
		if (icon14) icon14Color = iconHover
		else icon14Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bTTB')
	}

	const set_icon_15 = () => {
		selectedTitleBorderIcon = true
		selectedIcon = 'icon15'
		storeSelectedIcon.set('icon15')
		icon15 = icon15 === false ? true : false
		if (icon15) icon15Color = iconHover
		else icon15Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bTTA')
	}

	const set_icon_16 = () => {
		selectedTextBorderIcon = true
		selectedIcon = 'icon16'
		storeSelectedIcon.set('icon16')
		icon16 = icon16 === false ? true : false
		if (icon16) icon16Color = iconHover
		else icon16Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bTXTL')
	}

	const set_icon_17 = () => {
		selectedTextBorderIcon = true
		selectedIcon = 'icon17'
		storeSelectedIcon.set('icon17')
		icon17 = icon17 === false ? true : false
		if (icon17) icon17Color = iconHover
		else icon17Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bTXTT')
	}

	const set_icon_18 = () => {
		selectedTextBorderIcon = true
		selectedIcon = 'icon18'
		storeSelectedIcon.set('icon18')
		icon18 = icon18 === false ? true : false
		if (icon18) icon18Color = iconHover
		else icon18Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bTXTR')
	}

	const set_icon_19 = () => {
		selectedTextBorderIcon = true
		selectedIcon = 'icon19'
		storeSelectedIcon.set('icon19')
		icon19 = icon19 === false ? true : false
		if (icon19) icon19Color = iconHover
		else icon19Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bTXTB')
	}

	const set_icon_20 = () => {
		selectedTextBorderIcon = true
		selectedIcon = 'icon20'
		storeSelectedIcon.set('icon20')
		icon20 = icon20 === false ? true : false
		if (icon20) icon20Color = iconHover
		else icon20Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bTXTA')
	}

	const add_line_break = (cmd, start, end) => {
		let lineBreak
		let newText
		if (cmd === 'linebreak') lineBreak = '\n'
		if (cmd === 'paragraph') lineBreak = '\n\n'
		if (cmd === 'indent') lineBreak = '  '
		let text = document.getElementById(selectedTextId).innerText
		let slice = text.slice(start, end)
		let head = text.slice(0, start)
		let tail = text.slice(end, text.length)
		if (cmd !== 'indent' || cmd !== 'resindent') {
			slice = slice + lineBreak
			newText = head + slice + tail
		}
		if (cmd === 'indent') {
			slice = lineBreak + slice
			const newSlice = slice.replace(/\s+$/, '')
			newText = head + newSlice + tail
		}

		if (cmd === 'resindent') {
			let newSlice = text.substring(start, end)
			let trimSlice = newSlice.trim()
			newText = head + trimSlice + tail
		}

		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.content[0].text = newText
			}
		})

		config.blocks = blocks
		storeData.set(config)
	}

	const set_linebreak = () => {
		if (document.getSelection) {
			const selectedText = document.getSelection()
			const start = selectedText.focusOffset
			const end = selectedText.anchorOffset
			if (start === 0 && end === 0) return
			add_line_break('linebreak', start, end)
		}
	}

	const set_paragraph = () => {
		if (document.getSelection) {
			const selectedText = document.getSelection()
			const start = selectedText.focusOffset
			const end = selectedText.anchorOffset
			if (start === 0 && end === 0) return
			add_line_break('paragraph', start, end)
		}
	}

	const set_indent = () => {
		if (document.getSelection) {
			const selectedText = document.getSelection()
			const start = selectedText.focusOffset
			const end = selectedText.anchorOffset
			if (start === 0 && end === 0) return
			add_line_break('indent', start, end)
		}
	}

	const reset_indent = () => {
		const selectedText = document.getSelection()
		const start = selectedText.focusOffset
		const end = selectedText.anchorOffset
		if (start === 0 && end === 0) return
		add_line_break('resindent', start, end)
	}

	const reset_paragraph = () => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				const text = block.content[0].text.split('\n')
				const newText = text.join('')
				block.content[0].text = newText
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const change_order = async (block, direction) => {
		let changeOrder = true
		blocks = get_blocks(config)
		blocks.forEach((bl) => {
			if (bl.blockName === block && bl.layoutOrder === 0 && direction === 'up') {
				changeOrder = false
			}

			if (bl.blockName === block && bl.layoutOrder === blocks.length - 1 && direction === 'down') {
				changeOrder = false
			}
		})
		if (changeOrder) {
			shaderChangeOrder = true
			const reorder = await reorder_layout(block, direction)
			storeData.set(reorder)
			shaderChangeOrder = false
		}
	}

	let toTool
	const open_tool = (t) => {
		switch (t) {
			case 'generalTool1':
				generalTool1 = generalTool1 === true ? false : true
				showTool2 = false
				showTool3 = false
				break

			case 'generalTool2':
				generalTool2 = generalTool2 === true ? false : true
				showTool5 = false
				showTool6 = false
				break

			case 'generalTool3':
				generalTool3 = generalTool3 === true ? false : true
				showTool8 = false
				showTool9 = false
				showTool10 = false
				showTool11 = false
				break
			case 'generalTool4':
				generalTool4 = generalTool4 === true ? false : true
				showTool13 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				showTool17 = false
				showTool18 = false
				break
			case 0:
				showTool0 = showTool0 === true ? false : true
				showTool1 = false
				showTool4 = false
				showTool7 = false
				showTool12 = false
				showTool18 = false
				break
			case 1:
				showTool1 = showTool1 === true ? false : true
				showTool0 = false
				showTool4 = false
				showTool7 = false
				showTool12 = false
				showTool18 = false
				break

			case 2:
				showTool2 = showTool2 === true ? false : true
				generalTool1 = false
				showTool3 = false

				if (showTool2) {
					if (!icon1) icon1Color = iconColor
					if (!icon2) icon2Color = iconColor
					if (!icon3) icon3Color = iconColor
					if (!icon4) icon4Color = iconColor
					if (!icon1 || !icon2 || !icon3 || !icon4) icon5Color = iconColor

					toTool = setTimeout(() => {
						icon1Color = icon1Color
						icon2Color = icon2Color
						icon3Color = icon3Color
						icon4Color = icon4Color
						icon5Color = icon5Color
					}, 10)
				}
				break

			case 3:
				showTool3 = showTool3 === true ? false : true
				generalTool1 = false
				showTool2 = false
				break

			case 4:
				showTool4 = showTool4 === true ? false : true
				showTool0 = false
				showTool1 = false
				showTool7 = false
				showTool12 = false
				showTool18 = false
				break

			case 5:
				showTool5 = showTool5 === true ? false : true
				generalTool2 = false
				showTool6 = false
				if (showTool5) {
					if (!icon6) icon6Color = iconColor
					if (!icon7) icon7Color = iconColor
					if (!icon8) icon8Color = iconColor
					if (!icon9) icon9Color = iconColor
					if (!icon6 || !icon7 || !icon8 || !icon9) icon10Color = iconColor

					toTool = setTimeout(() => {
						icon6Color = icon6Color
						icon7Color = icon7Color
						icon8Color = icon8Color
						icon9Color = icon9Color
						icon10Color = icon10Color
					}, 10)
				}
				break

			case 6:
				showTool6 = showTool6 === true ? false : true
				generalTool2 = false
				showTool5 = false

				break

			case 7:
				showTool7 = showTool7 === true ? false : true
				showTool1 = false
				showTool4 = false
				showTool0 = false
				showTool12 = false
				showTool18 = false
				break

			case 8:
				showTool8 = showTool8 === true ? false : true
				generalTool3 = false
				showTool9 = false
				showTool10 = false
				showTool11 = false
				if (showTool8) {
					if (!icon11) icon11Color = iconColor
					if (!icon12) icon12Color = iconColor
					if (!icon13) icon13Color = iconColor
					if (!icon14) icon14Color = iconColor
					if (!icon11 || !icon12 || !icon13 || !icon14) icon15Color = iconColor

					toTool = setTimeout(() => {
						icon11Color = icon11Color
						icon12Color = icon12Color
						icon13Color = icon13Color
						icon14Color = icon14Color
						icon15Color = icon15Color
					}, 10)
				}
				break

			case 9:
				showTool9 = showTool9 === true ? false : true
				generalTool3 = false
				showTool8 = false
				showTool10 = false
				showTool11 = false
				break

			case 10:
				showTool10 = showTool10 === true ? false : true
				generalTool3 = false
				showTool8 = false
				showTool9 = false
				showTool11 = false
				break

			case 11:
				showTool11 = showTool11 === true ? false : true
				generalTool3 = false
				showTool8 = false
				showTool9 = false
				showTool10 = false
				break

			case 12:
				showTool12 = showTool12 === true ? false : true
				showTool1 = false
				showTool4 = false
				showTool7 = false
				showTool0 = false
				showTool18 = false
				showTool19 = false
				break

			case 13:
				showTool13 = showTool13 === true ? false : true
				generalTool4 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				showTool17 = false
				showTool18 = false
				showTool19 = false
				if (showTool13) {
					if (!icon16) icon1Color = iconColor
					if (!icon17) icon2Color = iconColor
					if (!icon18) icon3Color = iconColor
					if (!icon19) icon4Color = iconColor
					if (!icon16 || !icon17 || !icon18 || !icon19) icon20Color = iconColor

					toTool = setTimeout(() => {
						icon16Color = icon16Color
						icon17Color = icon17Color
						icon18Color = icon18Color
						icon19Color = icon19Color
						icon20Color = icon20Color
					}, 10)
				}
				break

			case 14:
				showTool14 = showTool14 === true ? false : true
				generalTool4 = false
				showTool13 = false
				showTool15 = false
				showTool16 = false
				showTool17 = false
				showTool18 = false
				showTool19 = false
				break

			case 15:
				showTool15 = showTool15 === true ? false : true
				generalTool4 = false
				showTool14 = false
				showTool13 = false
				showTool16 = false
				showTool17 = false
				showTool18 = false
				showTool19 = false
				break

			case 16:
				showTool16 = showTool16 === true ? false : true
				generalTool4 = false
				showTool14 = false
				showTool15 = false
				showTool13 = false
				showTool17 = false
				showTool18 = false
				showTool19 = false
				break

			case 17:
				showTool17 = showTool17 === true ? false : true
				generalTool4 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				showTool13 = false
				showTool18 = false
				showTool19 = false
				break

			case 18:
				showTool18 = showTool18 === true ? false : true
				generalTool4 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				showTool17 = false
				showTool13 = false
				showTool19 = false
				break

			case 19:
				showTool19 = showTool19 === true ? false : true
				showTool18 = false
				generalTool4 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				showTool17 = false
				showTool13 = false
				break
		}
	}

	onDestroy(() => {
		stoElementID
		stoData
		stoSelectedIcon
		stoTemplate
		clearTimeout(toTool)
	})
</script>

{#if config}
	<main use:styles={{ width }}>
		<div class="title" use:styles={{ fsS, bgTitle }} />

		<div
			class="part_title mainTool"
			on:click={() => open_tool(0)}
			on:keydown={() => open_tool(0)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			LAYOUT POSITION
		</div>
		{#if showTool0}
			<div transition:slide={{ duration: 500 }}>
				
					<div class="icon_container">
						<div
							class="icon arrow_down"
							use:styles={{ icon, iconColor, iconHover }}
							on:click={() => change_order(blockID, 'down')}
							on:keydown={() => change_order(blockID, 'down')}
						/>
						<div
							class="icon arrow_up"
							use:styles={{ icon, iconColor, iconHover }}
							on:click={() => change_order(blockID, 'up')}
							on:keydown={() => change_order(blockID, 'up')}
						/>
					</div>
			</div>
		{/if}
		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(1)}
				on:keydown={() => open_tool(1)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				BLOCK CONTAINER
			</div>
			{#if showTool1}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool1')}
						on:keydown={() => open_tool('generalTool1')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool1}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_bg_color}
								on:setopacity={set_bg_color}
								on:settransparent={set_bg_color}
								transparent="1"
								ID={idColor1}
								selectedColor={selectedBackground}
								initialValue={selectedBgOpac}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Height</div>
							<SizeSelector
								ID={idHeight}
								range="100"
								unit="%"
								initialValue={selectedHeight}
								on:sizechange={set_height}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector
								ID={idMarginTop}
								range="5"
								initialValue={selectedMarginTop}
								on:sizechange={set_margin_top}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector
								ID={idMarginBottom}
								range="5"
								initialValue={selectedMarginBottom}
								on:sizechange={set_margin_bottom}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
							<SizeSelector ID={idPadding} range="5" initialValue={selectedPadding} on:sizechange={set_padding} />
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(2)}
						on:keydown={() => open_tool(2)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						border
					</div>
					{#if showTool2}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="icon1"
									class="icon icon1"
									use:styles={{ icon, icon1Color, iconHover }}
									on:click={set_icon_1}
									on:keydown={set_icon_1}
								/>
								<div
									id="icon2"
									class="icon icon2"
									use:styles={{ icon, icon2Color, iconHover }}
									on:click={set_icon_2}
									on:keydown={set_icon_2}
								/>
								<div
									id="icon3"
									class="icon icon3"
									use:styles={{ icon, icon3Color, iconHover }}
									on:click={set_icon_3}
									on:keydown={set_icon_3}
								/>
								<div
									id="icon4"
									class="icon icon4"
									use:styles={{ icon, icon4Color, iconHover }}
									on:click={set_icon_4}
									on:keydown={set_icon_4}
								/>
								<div
									id="icon5"
									class="icon icon5"
									use:styles={{ icon, icon5Color, iconHover }}
									on:click={set_icon_5}
									on:keydown={set_icon_5}
								/>
							</div>
							{#if iconSelected}
								<div in:slide={{ duration: 500 }}>
									<div class="sub_title" use:styles={{ fsXS }}>Border Color</div>
									<ColorSelector
										on:setcolor={set_border_color}
										on:setopacity={set_border_color}
										ID={idColor2}
										selectedColor={selectedBorderColor}
										initialValue={selectedBgOpac}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Border Width</div>
									<SizeSelector
										ID={idBorderWidth}
										range="50"
										unit="px"
										initialValue={selectedBorderWidth}
										on:sizechange={set_border_width}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Border Top Radius</div>
									<SizeSelector
										ID={idBTradius}
										initialValue={selectedBTradius}
										unit="px"
										range="20"
										on:sizechange={set_border_top_radius}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Border Bottom Radius</div>
									<SizeSelector
										ID={idBBradius}
										initialValue={selectedBBradius}
										range="20"
										unit="px"
										on:sizechange={set_border_bottom_radius}
									/>
								</div>
							{/if}
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(3)}
						on:keydown={() => open_tool(3)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						shadow
					</div>
					{#if showTool3}
						<div transition:slide={{ duration: 500 }}>
							<ColorSelector
								on:setcolor={set_shadow_color}
								on:setopacity={set_shadow_color}
								ID={idColor3}
								selectedColor={selectedSColor}
								selectedOpac={selectedSOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idShadowY}
								range="20"
								unit="px"
								initialValue={selectedSY}
								on:sizechange={set_offset_y}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idShadowBlur}
								range="20"
								unit="px"
								initialValue={selectedSBlur}
								on:sizechange={set_blur}
							/>
						</div>
					{/if}
				</div>
			{/if}
		</section>

		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(4)}
				on:keydown={() => open_tool(4)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				IMAGE CONTAINER
			</div>
			{#if showTool4}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool2')}
						on:keydown={() => open_tool('generalTool2')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool2}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Width</div>
							<SizeSelector
								ID={idImageWidth}
								range="100"
								unit="%"
								initialValue={selectedImageWidth}
								on:sizechange={set_image_width}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Height</div>
							<SizeSelector
								ID={idImageHeight}
								range="100"
								initialValue={selectedImageHeight}
								on:sizechange={set_image_height}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Left</div>
							<SizeSelector
								ID={idImageLeft}
								range="100"
								unit="%"
								initialValue={selectedImageLeft}
								on:sizechange={set_image_left}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Top</div>
							<SizeSelector ID={idImageTop} range="100" initialValue={selectedImageTop} on:sizechange={set_image_top} />
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(5)}
						on:keydown={() => open_tool(5)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						border
					</div>
					{#if showTool5}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="icon6"
									class="icon icon6"
									use:styles={{ icon, icon6Color, iconHover }}
									on:click={set_icon_6}
									on:keydown={set_icon_6}
								/>
								<div
									id="icon7"
									class="icon icon7"
									use:styles={{ icon, icon7Color, iconHover }}
									on:click={set_icon_7}
									on:keydown={set_icon_7}
								/>
								<div
									id="icon8"
									class="icon icon8"
									use:styles={{ icon, icon8Color, iconHover }}
									on:click={set_icon_8}
									on:keydown={set_icon_8}
								/>
								<div
									id="icon9"
									class="icon icon9"
									use:styles={{ icon, icon9Color, iconHover }}
									on:click={set_icon_9}
									on:keydown={set_icon_9}
								/>
								<div
									id="icon10"
									class="icon icon10"
									use:styles={{ icon, icon10Color, iconHover }}
									on:click={set_icon_10}
									on:keydown={set_icon_10}
								/>
							</div>
							{#if selectedImageBorderIcon}
								<div in:slide={{ duration: 500 }}>
									<div class="sub_title" use:styles={{ fsXS }}>Color</div>
									<ColorSelector
										on:setcolor={set_image_border_color}
										on:setopacity={set_image_border_color}
										ID={idColor4}
										selectedColor={selectedImageBorderColor}
										initialValue={selectedImageBgOpac}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Width</div>
									<SizeSelector
										ID={idImageBorderWidth}
										range="50"
										unit="px"
										initialValue={selectedImageBorderWidth}
										on:sizechange={set_image_border_width}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Top Radius</div>
									<SizeSelector
										ID={idImageBTradius}
										initialValue={selectedBITradius}
										unit="px"
										range="20"
										on:sizechange={set_image_border_top_radius}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Bottom Radius</div>
									<SizeSelector
										ID={idImageBBradius}
										initialValue={selectedBIBradius}
										range="20"
										unit="px"
										on:sizechange={set_image_border_bottom_radius}
									/>
								</div>
							{/if}
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(6)}
						on:keydown={() => open_tool(6)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						shadow
					</div>
					{#if showTool6}
						<div transition:slide={{ duration: 500 }}>
							<ColorSelector
								on:setcolor={set_image_shadow_color}
								on:setopacity={set_image_shadow_color}
								ID={idColor5}
								selectedColor={selectedBIScolor}
								initialValue={selectedBISopac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idImageShadowX}
								unit="px"
								range="20"
								initialValue={selectedSIX}
								on:sizechange={set_image_offset_x}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idImageShadowY}
								unit="px"
								range="20"
								initialValue={selectedSIY}
								on:sizechange={set_image_offset_y}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idImageShadowBlur}
								unit="px"
								range="20"
								initialValue={selectedSIBlur}
								on:sizechange={set_image_blur}
							/>
						</div>
					{/if}
				</div>
			{/if}
		</section>

		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(7)}
				on:keydown={() => open_tool(7)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				TITLE CONTAINER
			</div>
			{#if showTool7}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool3')}
						on:keydown={() => open_tool('generalTool3')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool3}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background Color</div>
							<ColorSelector
								on:setcolor={set_title_bg_color}
								on:setopacity={set_title_bg_color}
								on:settransparent={set_title_bg_color}
								transparent="1"
								ID={idColor6}
								selectedColor={selectedTitleBgColor}
								initialValue={selectedTitleBgOpac}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Width</div>
							<SizeSelector
								ID={idTitleWidth}
								range="100"
								unit="%"
								initialValue={selectedTitleWidth}
								on:sizechange={set_title_width}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Height</div>
							<SizeSelector
								ID={idTitleHeight}
								range="100"
								unit="%"
								initialValue={selectedTitleHeight}
								on:sizechange={set_title_height}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Left</div>
							<SizeSelector
								ID={idTitleLeft}
								range="100"
								unit="%"
								initialValue={selectedTitleLeft}
								on:sizechange={set_title_left}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Top</div>
							<SizeSelector
								ID={idTitleTop}
								range="100"
								unit="%"
								initialValue={selectedTitleTop}
								on:sizechange={set_title_top}
							/>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(8)}
						on:keydown={() => open_tool(8)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						border
					</div>
					{#if showTool8}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="icon11"
									class="icon icon11"
									use:styles={{ icon, icon11Color, iconHover }}
									on:click={set_icon_11}
									on:keydown={set_icon_11}
								/>
								<div
									id="icon12"
									class="icon icon12"
									use:styles={{ icon, icon12Color, iconHover }}
									on:click={set_icon_12}
									on:keydown={set_icon_12}
								/>
								<div
									id="icon13"
									class="icon icon13"
									use:styles={{ icon, icon13Color, iconHover }}
									on:click={set_icon_13}
									on:keydown={set_icon_13}
								/>
								<div
									id="icon14"
									class="icon icon14"
									use:styles={{ icon, icon14Color, iconHover }}
									on:click={set_icon_14}
									on:keydown={set_icon_14}
								/>
								<div
									id="icon15"
									class="icon icon15"
									use:styles={{ icon, icon15Color, iconHover }}
									on:click={set_icon_15}
									on:keydown={set_icon_15}
								/>
							</div>
							{#if selectedTitleBorderIcon}
								<div in:slide={{ duration: 500 }}>
									<div class="sub_title" use:styles={{ fsXS }}>Color</div>
									<ColorSelector
										on:setcolor={set_title_border_color}
										on:setopacity={set_title_border_color}
										ID={idColor7}
										selectedColor={selectedTitleBorderColor}
										initialValue={selectedTitleBorderOpac}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Width</div>
									<SizeSelector
										ID={idTitleBorderWidth}
										range="20"
										unit="px"
										initialValue={selectedTitleBorderWidth}
										on:sizechange={set_title_border_width}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Top Radius</div>
									<SizeSelector
										ID={idTitleBTradius}
										initialValue={selectedBTTradius}
										unit="px"
										range="20"
										on:sizechange={set_title_border_top_radius}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Bottom Radius</div>
									<SizeSelector
										ID={idTitleBBradius}
										initialValue={selectedBTBradius}
										range="20"
										unit="px"
										on:sizechange={set_title_border_bottom_radius}
									/>
								</div>
							{/if}
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(9)}
						on:keydown={() => open_tool(9)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						font
					</div>
					{#if showTool9}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
							<ColorSelector on:setcolor={set_title_font_color} on:setopacity={set_title_font_color} ID={idColor8} />

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_title_font_family}
								value={selectedTitleFontFamily}
								ID={idSelect1}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSize}
								on:select={set_title_font_size}
								value={selectedTitleFontSize}
								ID={idSelect2}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
							<div class="icon_container">
								<div
									id="fweight"
									class="icon iconTitleWeight"
									use:styles={{ icon, iconTitleWeight, iconHover }}
									on:click={set_title_font_weight}
									on:keydown={set_title_font_weight}
								/>
								<div
									id="fstyle"
									class="icon iconTitleStyle"
									use:styles={{ icon, iconTitleStyle, iconHover }}
									on:click={set_title_font_style}
									on:keydown={set_title_font_style}
								/>
								<div
									id="fdeco"
									class="icon iconTitleDeco"
									use:styles={{ icon, iconTitleDeco, iconHover }}
									on:click={set_title_font_underline}
									on:keydown={set_title_font_underline}
								/>
								<div
									id="fstroke"
									class="icon iconTitleStroke"
									use:styles={{ icon, iconTitleStroke, iconHover }}
									on:click={set_title_font_strikethrough}
									on:keydown={set_title_font_strikethrough}
								/>
							</div>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(19)}
						on:keydown={() => open_tool(19)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						font shadow
					</div>

					{#if showTool19}
						<div transition:slide={{ duration: 500 }}>
							<ColorSelector
								on:setcolor={set_titleTXTSC}
								on:setopacity={set_shadow_color}
								ID={idColor15}
								selectedColor={titleTXTSC}
								selectedOpac={titleTXTSO}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idTXTSX}
								range="20"
								unit="px"
								initialValue={titleTXTSX}
								on:sizechange={set_titleTXTSX}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idTXTSY}
								range="20"
								unit="px"
								initialValue={titleTXTSY}
								on:sizechange={set_titleTXTSY}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idTXTSB}
								range="20"
								unit="px"
								initialValue={titleTXTSB}
								on:sizechange={set_titleTXTSB}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(10)}
						on:keydown={() => open_tool(10)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						alignment
					</div>
					{#if showTool10}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="fAlignL"
									class="icon txtAlignL"
									use:styles={{ icon, iconTitleAlignL, iconHover }}
									on:click={set_flex_align_left_title}
									on:keydown={set_flex_align_left_title}
								/>

								<div
									id="fAlignC"
									class="icon txtAlignC"
									use:styles={{ icon, iconTitleAlignC, iconHover }}
									on:click={set_flex_align_center_title}
									on:keydown={set_flex_align_center_title}
								/>

								<div
									id="fAlignR"
									class="icon txtAlignR"
									use:styles={{ icon, iconTitleAlignR, iconHover }}
									on:click={set_flex_align_right_title}
									on:keydown={set_flex_align_right_title}
								/>
							</div>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(11)}
						on:keydown={() => open_tool(11)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						shadow
					</div>
					{#if showTool11}
						<div transition:slide={{ duration: 500 }}>
							<ColorSelector
								on:setcolor={set_title_shadow_color}
								on:setopacity={set_title_shadow_color}
								ID={idColor9}
								selectedColor={selectedBTScolor}
								initialValue={selectedBTSopac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idTitleShadowX}
								unit="px"
								range="20"
								initialValue={selectedSTX}
								on:sizechange={set_title_offset_x}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idTitleShadowY}
								unit="px"
								range="20"
								initialValue={selectedSTY}
								on:sizechange={set_title_offset_y}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idTitleShadowBlur}
								unit="px"
								range="20"
								initialValue={selectedSTBlur}
								on:sizechange={set_title_blur}
							/>
						</div>
					{/if}
				</div>
			{/if}
		</section>

		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(12)}
				on:keydown={() => open_tool(12)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				TEXT CONTAINER
			</div>
			{#if showTool12}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool4')}
						on:keydown={() => open_tool('generalTool4')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool4}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background Color</div>
							<ColorSelector
								on:setcolor={set_text_bg_color}
								on:setopacity={set_text_bg_color}
								on:settransparent={set_text_bg_color}
								transparent="1"
								ID={idColor11}
								selectedColor={selectedTextBgColor}
								initialValue={selectedTextBgOpac}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Width</div>
							<SizeSelector
								ID={idTextWidth}
								range="100"
								unit="%"
								initialValue={selectedTextWidth}
								on:sizechange={set_text_width}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Left</div>
							<SizeSelector
								ID={idTextLeft}
								range="100"
								unit="%"
								initialValue={selectedTextLeft}
								on:sizechange={set_text_left}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Top</div>
							<SizeSelector
								ID={idTextTop}
								range="100"
								unit="%"
								initialValue={selectedTextTop}
								on:sizechange={set_text_top}
							/>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(13)}
						on:keydown={() => open_tool(13)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						border
					</div>
					{#if showTool13}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="icon16"
									class="icon icon16"
									use:styles={{ icon, icon16Color, iconHover }}
									on:click={set_icon_16}
									on:keydown={set_icon_16}
								/>
								<div
									id="icon17"
									class="icon icon17"
									use:styles={{ icon, icon17Color, iconHover }}
									on:click={set_icon_17}
									on:keydown={set_icon_17}
								/>
								<div
									id="icon18"
									class="icon icon18"
									use:styles={{ icon, icon18Color, iconHover }}
									on:click={set_icon_18}
									on:keydown={set_icon_18}
								/>
								<div
									id="icon19"
									class="icon icon19"
									use:styles={{ icon, icon19Color, iconHover }}
									on:click={set_icon_19}
									on:keydown={set_icon_19}
								/>
								<div
									id="icon20"
									class="icon icon20"
									use:styles={{ icon, icon20Color, iconHover }}
									on:click={set_icon_20}
									on:keydown={set_icon_20}
								/>
							</div>
							{#if selectedTextBorderIcon}
								<div in:slide={{ duration: 500 }}>
									<div class="sub_title" use:styles={{ fsXS }}>Border Color</div>
									<ColorSelector
										on:setcolor={set_text_border_color}
										on:setopacity={set_text_border_color}
										ID={idColor10}
										selectedColor={selectedTextBorderColor}
										initialValue={selectedTextBorderOpac}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Border Width</div>
									<SizeSelector
										ID={idTextBorderWidth}
										range="20"
										unit="px"
										initialValue={selectedTextBorderWidth}
										on:sizechange={set_text_border_width}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Border Top Radius</div>
									<SizeSelector
										ID={idTextBTradius}
										initialValue={selectedBTXTTradius}
										unit="px"
										range="20"
										on:sizechange={set_text_border_top_radius}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Border Bottom Radius</div>
									<SizeSelector
										ID={idTextBBradius}
										initialValue={selectedBTXTBradius}
										range="20"
										unit="px"
										on:sizechange={set_text_border_bottom_radius}
									/>
								</div>
							{/if}
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(14)}
						on:keydown={() => open_tool(14)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						font
					</div>
					{#if showTool14}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
							<ColorSelector on:setcolor={set_text_font_color} on:setopacity={set_text_font_color} ID={idColor12} />

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_text_font_family}
								value={selectedTextFontFamily}
								ID={idSelect3}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSize}
								on:select={set_text_font_size}
								value={selectedTextFontSize}
								ID={idSelect4}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
							<div class="icon_container">
								<div
									id="fTXTweight"
									class="icon iconTextWeight"
									use:styles={{ icon, iconTextWeight, iconHover }}
									on:click={set_text_font_weight}
									on:keydown={set_text_font_weight}
								/>
								<div
									id="fTXTstyle"
									class="icon iconTextStyle"
									use:styles={{ icon, iconTextStyle, iconHover }}
									on:click={set_text_font_style}
									on:keydown={set_text_font_style}
								/>
								<div
									id="fTXTdeco"
									class="icon iconTextDeco"
									use:styles={{ icon, iconTextDeco, iconHover }}
									on:click={set_text_font_underline}
									on:keydown={set_text_font_underline}
								/>
								<div
									id="fTXTstroke"
									class="icon iconTextStroke"
									use:styles={{ icon, iconTextStroke, iconHover }}
									on:click={set_text_font_strikethrough}
									on:keydown={set_text_font_strikethrough}
								/>
							</div>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(15)}
						on:keydown={() => open_tool(15)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						alignment
					</div>
					{#if showTool15}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="fTXTAlignL"
									class="icon txtTXTAlignL"
									use:styles={{ icon, iconTextAlignL, iconHover }}
									on:click={set_flex_align_left_text}
									on:keydown={set_flex_align_left_text}
								/>

								<div
									id="fTXTAlignC"
									class="icon txtTXTAlignC"
									use:styles={{ icon, iconTextAlignC, iconHover }}
									on:click={set_flex_align_center_text}
									on:keydown={set_flex_align_center_text}
								/>

								<div
									id="fTXTAlignR"
									class="icon txtTXTAlignR"
									use:styles={{ icon, iconTextAlignR, iconHover }}
									on:click={set_flex_align_right_text}
									on:keydown={set_flex_align_right_text}
								/>

								<div
									id="fTXTAlignJ"
									class="icon txtTXTAlignJ"
									use:styles={{ icon, iconTextAlignJ, iconHover }}
									on:click={set_flex_align_justify_text}
									on:keydown={set_flex_align_justify_text}
								/>
							</div>
							<!-- <div class="icon_container">
							<div
								id="fTXTVAlignT"
								class="icon txtTXTVAlignT"
								use:styles={{ icon, iconTextVAlignT, iconHover }}
								on:click={set_flex_valign_top_text}
								on:keydown={set_flex_valign_top_text}
							/>

							<div
								id="fTXTVAlignC"
								class="icon txtTXTVAlignC"
								use:styles={{ icon, iconTextVAlignC, iconHover }}
								on:keydown={set_flex_valign_center_text}
							/>

							<div
								id="fTXTVAlignB"
								class="icon txtTXTVAlignB"
								use:styles={{ icon, iconTextVAlignB, iconHover }}
								on:click={set_flex_valign_bottom_text}
								on:keydown={set_flex_valign_bottom_text}
							/>
						</div> -->
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(16)}
						on:keydown={() => open_tool(16)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						shadow
					</div>
					{#if showTool16}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_text_shadow_color}
								on:setopacity={set_text_shadow_color}
								ID={idColor13}
								selectedColor={selectedBTXTScolor}
								initialValue={selectedBTXTSopac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idTextShadowX}
								unit="px"
								range="20"
								initialValue={selectedSTXTX}
								on:sizechange={set_text_offset_x}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idTextShadowY}
								unit="px"
								range="20"
								initialValue={selectedSTXTY}
								on:sizechange={set_text_offset_y}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idTextShadowBlur}
								unit="px"
								range="20"
								initialValue={selectedSTXTBlur}
								on:sizechange={set_text_blur}
							/>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(17)}
						on:keydown={() => open_tool(17)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						paragraph
					</div>
					{#if showTool17}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="lb"
									class="icon linebreak"
									use:styles={{ icon, iconColor, iconHover }}
									on:click={set_linebreak}
									on:keydown={set_linebreak}
								/>
								<div
									id="paragraph"
									class="icon paragraph"
									use:styles={{ icon, iconColor, iconHover }}
									on:click={set_paragraph}
									on:keydown={set_paragraph}
								/>

								<div
									id="indent"
									class="icon indent"
									use:styles={{ icon, iconColor, iconHover }}
									data-indent
									on:click={set_indent}
									on:keydown={set_indent}
								/>

								<div
									id="resIndent"
									class="icon resIndent"
									use:styles={{ icon, iconColor, iconHover }}
									on:click={reset_indent}
									on:keydown={reset_indent}
								/>
								<div
									id="resAlign"
									class="icon resAlign"
									use:styles={{ icon, iconColor, iconHover }}
									on:click={reset_paragraph}
									on:keydown={reset_paragraph}
								/>
							</div>
						</div>
					{/if}
				</div>
			{/if}
		</section>

		{#if selectedLogo}
			<section>
				<div>
					<div
						class="part_title mainTool"
						on:click={() => open_tool(18)}
						on:keydown={() => open_tool(18)}
						use:styles={{ mainTool, mainToolHover, fsXS }}
					>
						LOGO CONTAINER
					</div>
					{#if showTool18}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background Color</div>
							<ColorSelector
								on:setcolor={set_logo_bg_color}
								on:setopacity={set_logo_bg_color}
								on:settransparent={set_logo_bg_color}
								transparent="1"
								ID={idColor14}
								selectedColor={selectedLogoBgColor}
								initialValue={selectedLogoBgOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Size</div>
							<SizeSelector
								ID={idLogoSize}
								unit="%"
								range="100"
								initialValue={selectedLogoHeight}
								on:sizechange={set_logo_height}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Left</div>
							<SizeSelector
								ID={idLogoLeft}
								unit="%"
								range="100"
								initialValue={selectedLogoLeft}
								on:sizechange={set_logo_left}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Top</div>
							<SizeSelector
								ID={idLogoTop}
								unit="%"
								range="100"
								initialValue={selectedLogoTop}
								on:sizechange={set_logo_top}
							/>
						</div>
					{/if}
				</div>
			</section>
		{/if}
	</main>
{/if}

{#if shaderChangeOrder}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" info="change block order" />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: var(--with);
		user-select: none;
	}
	.title,
	.sub_title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		font-size: var(--fsS);
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.title {
		border-top: 1px solid black;
		border-bottom: 1px solid black;
		background-color: var(--bgTitle);
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.sub_title {
		border-bottom: none;
		padding: 10px 0px 3px 10px;
		font-size: var(--fsXS);
	}

	.icon_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
		padding: 2%;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		mask-size: cover;
		-webkit-mask-size: cover;
		cursor: pointer;
	}

	.icon:hover {
		background-color: var(--iconHover);
	}

	.arrow_down {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrow_down.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_down.svg') no-repeat;
	}

	.arrow_up {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrow_up.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_up.svg') no-repeat;
	}

	.iconTitleWeight {
		background-color: var(--iconColor);
		background-color: var(--iconTitleWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconTextWeight {
		background-color: var(--iconColor);
		background-color: var(--iconTextWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconTitleStyle {
		background-color: var(--iconColor);
		background-color: var(--iconTitleStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.iconTextStyle {
		background-color: var(--iconColor);
		background-color: var(--iconTextStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.iconTitleDeco {
		background-color: var(--iconColor);
		background-color: var(--iconTitleDeco);
		mask: url('/images/tools/fontU.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontU.svg') no-repeat;
	}

	.iconTextDeco {
		background-color: var(--iconColor);
		background-color: var(--iconTextDeco);
		mask: url('/images/tools/fontU.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontU.svg') no-repeat;
	}

	.iconTitleStroke {
		background-color: var(--iconColor);
		background-color: var(--iconTitleStroke);
		mask: url('/images/tools/fontST.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontST.svg') no-repeat;
	}

	.iconTextStroke {
		background-color: var(--iconColor);
		background-color: var(--iconTextStroke);
		mask: url('/images/tools/fontST.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontST.svg') no-repeat;
	}

	.txtAlignL {
		background-color: var(--iconTitleAlignL);
		mask: url('/images/tools/alignL.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignL.svg') no-repeat;
	}

	.txtAlignC {
		background-color: var(--iconTitleAlignC);
		mask: url('/images/tools/alignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignC.svg') no-repeat;
	}

	.txtAlignR {
		background-color: var(--iconTitleAlignR);
		mask: url('/images/tools/alignR.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignR.svg') no-repeat;
	}

	.txtTXTAlignL {
		background-color: var(--iconTextAlignL);
		mask: url('/images/tools/alignL.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignL.svg') no-repeat;
	}

	.txtTXTAlignC {
		background-color: var(--iconTextAlignC);
		mask: url('/images/tools/alignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignC.svg') no-repeat;
	}

	.txtTXTAlignR {
		background-color: var(--iconTextAlignR);
		mask: url('/images/tools/alignR.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignR.svg') no-repeat;
	}

	.txtTXTAlignJ {
		background-color: var(--iconTextAlignJ);
		mask: url('/images/tools/alignJ.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignJ.svg') no-repeat;
	}

	/* .txtTXTVAlignT {
		background-color: var(--iconTextVAlignT);
		mask: url('/images/tools/valignT.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignT.svg') no-repeat;
	}

	.txtTXTVAlignC {
		background-color: var(--iconTextVAlignC);
		mask: url('/images/tools/valignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignC.svg') no-repeat;
	}

	.txtTXTVAlignB {
		background-color: var(--iconTextVAlignB);
		mask: url('/images/tools/valignB.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignB.svg') no-repeat;
	} */

	.linebreak {
		background-color: var(--iconColor);
		mask: url('/images/tools/lb.svg') no-repeat;
		-webkit-mask: url('/images/tools/lb.svg') no-repeat;
	}

	.paragraph {
		background-color: var(--iconColor);
		mask: url('/images/tools/para.svg') no-repeat;
		-webkit-mask: url('/images/tools/para.svg') no-repeat;
	}

	.indent {
		background-color: var(--iconColor);
		mask: url('/images/tools/indent.svg') no-repeat;
		-webkit-mask: url('/images/tools/indent.svg') no-repeat;
	}

	.resIndent {
		background-color: var(--iconColor);
		mask: url('/images/tools/resIndent.svg') no-repeat;
		-webkit-mask: url('/images/tools/resIndent.svg') no-repeat;
	}

	.resAlign {
		background-color: var(--iconColor);
		mask: url('/images/tools/alignReset.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignReset.svg') no-repeat;
	}

	.icon1,
	.icon6,
	.icon11,
	.icon16 {
		mask: url('/images/tools/borderL.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderL.svg') no-repeat;
	}

	.icon1 {
		background-color: var(--icon1Color);
	}

	.icon6 {
		background-color: var(--icon6Color);
	}

	.icon11 {
		background-color: var(--icon11Color);
	}

	.icon16 {
		background-color: var(--icon16Color);
	}

	.icon2,
	.icon7,
	.icon12,
	.icon17 {
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon2 {
		background-color: var(--icon2Color);
	}

	.icon7 {
		background-color: var(--icon7Color);
	}

	.icon12 {
		background-color: var(--icon12Color);
	}

	.icon17 {
		background-color: var(--icon17Color);
	}

	.icon3,
	.icon8,
	.icon13,
	.icon18 {
		mask: url('/images/tools/borderR.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderR.svg') no-repeat;
	}

	.icon3 {
		background-color: var(--icon3Color);
	}

	.icon8 {
		background-color: var(--icon8Color);
	}

	.icon13 {
		background-color: var(--icon13Color);
	}

	.icon18 {
		background-color: var(--icon18Color);
	}

	.icon4,
	.icon9,
	.icon14,
	.icon19 {
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.icon4 {
		background-color: var(--icon4Color);
	}

	.icon9 {
		background-color: var(--icon9Color);
	}

	.icon14 {
		background-color: var(--icon14Color);
	}

	.icon19 {
		background-color: var(--icon19Color);
	}

	.icon5,
	.icon10,
	.icon15,
	.icon20 {
		mask: url('/images/tools/borderA.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderA.svg') no-repeat;
	}

	.icon5 {
		background-color: var(--icon5Color);
	}

	.icon10 {
		background-color: var(--icon10Color);
	}

	.icon15 {
		background-color: var(--icon15Color);
	}

	.icon20 {
		background-color: var(--icon20Color);
	}

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}

	.subTool {
		background-color: var(--subTool);
	}

	.subTool:hover {
		background-color: var(--subToolHover);
	}
</style>
